import { useTranslation } from "react-i18next";
import { endMetadataMerge } from "../../lib/metadata-history/dispatch";
import { cn } from "../../lib/utils";

type TextColorSwatchesProps = {
  palette: string[];
  value: string;
  onChange: (color: string) => void;
};

export function TextColorSwatches({ palette, value, onChange }: TextColorSwatchesProps) {
  const { t } = useTranslation();
  if (!palette.length) return null;
  return (
    <div className="flex flex-wrap items-center gap-2">
      <span className="text-xs text-neutral-500">{t("builder.color.palette")}</span>
      <div className="grid min-w-40 flex-1 grid-cols-6 gap-1">
        {palette.map(color => <button key={color} type="button" title={color}
          className={cn("h-6 min-w-0 rounded border border-neutral-300 hover:ring-2 hover:ring-neutral-400",
            value.toLowerCase() === color && "ring-2 ring-neutral-900")}
          style={{ backgroundColor: color }} onClick={() => {
            endMetadataMerge();
            onChange(color);
            endMetadataMerge();
          }} />)}
      </div>
    </div>
  );
}
